import api from './api';

export const getServers = async (hostId) => {
  const url = hostId ? `/servers?host=${hostId}` : '/servers';
  const response = await api.get(url);
  return response.data.data;
};

export const getServer = async (id) => {
  const response = await api.get(`/servers/${id}`);
  return response.data.data;
};

export const createServer = async (serverData) => {
  const response = await api.post('/servers', serverData);
  return response.data.data;
};

export const updateServer = async (id, serverData) => {
  const response = await api.put(`/servers/${id}`, serverData);
  return response.data.data;
};

export const deleteServer = async (id) => {
  await api.delete(`/servers/${id}`);
};